export const testIsInstanceOfFileSystemFileHandle = (fileHandle?: any) => {
    if (!fileHandle || typeof FileSystemFileHandle === 'undefined') {
        return false;
    }

    return fileHandle instanceof FileSystemFileHandle;
};
